import { setExpiredAuth } from '../../../actions/ugMotorInsurance/quote';
import {
    apiTransitionOrderConfirmation,
    confirmOrderSuccess,
    confirmOrderFailure,
} from '../../../actions/ugMotorInsurance/payments';
import {
    getAccessToken,
    getIsConfirmOrderAPiPending,
    getStatusApiCallStatus,
} from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/ugMotorInsurance/quote';

export const orderConfirmationService = (store, next, action) => {
    (async () => {
        const confirmOrderApiIsPending = getIsConfirmOrderAPiPending(store.getState());
        const statusApiSuccess = getStatusApiCallStatus(store.getState()) === 'success';

        if (!confirmOrderApiIsPending && statusApiSuccess) {
            store.dispatch(apiTransitionOrderConfirmation.pending());
            try {
                const resp = await confirmInsuranceOrder(store.getState());

                store.dispatch(confirmOrderSuccess(resp.data));
                store.dispatch(apiTransitionOrderConfirmation.success());
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionOrderConfirmation.failure());
                store.dispatch(confirmOrderFailure(e));
            }
        }
    })();
    return next(action);
};

const confirmOrderPayload = (state) => {
    const customerId = getCustomerIdValue(state);

    const payload = {
        customer: customerId?.value,
    };

    return {
        ...payload,
    };
};

const confirmInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/order/confirmation';
        const response = await axios.post(url, confirmOrderPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        console.error(e);
        throw e;
    }
};
